module.exports = __webpack_public_path__ + "assets/angry-bird-30x30.cd1f16792f2aef034e094249281d9042.png";


/*****************
 ** WEBPACK FOOTER
 ** ./imgs/angry-bird-30x30.png
 ** module id = 180
 ** module chunks = 0
 **/